import api from '../../services/api';
import type { FaqData, FaqDataDTO } from '../../shared/interfaces/faq';
import type { ScreenData } from '../../shared/interfaces/screen';

const PopulateFaqScreens = async (
  faqDTOs: FaqDataDTO[],
): Promise<FaqData[]> => {
  const responseScreen = await api.get(`/tela`);

  let faqs: FaqData[] = [];
  for (let index = 0; index < faqDTOs.length; index++) {
    const faqDTO = faqDTOs[index];

    let faq: FaqData = {
      id: faqDTO.id,
      pergunta: faqDTO.pergunta,
      resposta: faqDTO.resposta,
    };

    faq.idTelas = responseScreen.data.filter(
      (s: ScreenData) =>
        faqDTO && faqDTO.idTelas && faqDTO.idTelas.includes(s.id),
    );

    faqs.push(faq);
  }

  return faqs;
};

export default PopulateFaqScreens;
